export const TAB_ISSUES = {
  ROOM_ISSUES: 'roomIssues',
  ASSET_ISSUES: 'assetIssues',
  AD_HOC_ISSUES: 'adHocIssues',
  ASSIGNMENTS: 'assignments'
} as const;

export const headerTabIssues = [
  { label: 'Location Issues', param: TAB_ISSUES.ROOM_ISSUES, value: 0 },
  { label: 'Asset Issues', param: TAB_ISSUES.ASSET_ISSUES, value: 1 },
  { label: 'Ad Hoc Issues', param: TAB_ISSUES.AD_HOC_ISSUES, value: 2 },
  { label: 'Assignments', param: TAB_ISSUES.ASSIGNMENTS, value: 3 }
];
